import { useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../Layouts/Loader/Loader";
import { useAppOrgContext } from "../../context/AppOrgContext";

import useQuery from "../../hooks/useQuery";
import { getApplicationLocksApi, getApplicationsApi } from "../../services/apis/applicationApis";

import ApplicationView from "./ApplicationView";
import { handleApiError } from "../../services/axiosService";

const Application = () => {
  const params = useParams();
  const { setAllApplications } = useAppOrgContext();

  const [lockedAppsMap, setLockedAppsMap] = useState({});

  const { data, isLoading, error } = useQuery(
    params.orgId,
    async ({ signal }) => {
      const [appsRes, locksRes] = await Promise.all([
        getApplicationsApi({ orgId: params.orgId, signal }),
        getApplicationLocksApi({ orgId: params.orgId, signal })
      ]);

      return {
        applications: appsRes.data,
        locks: locksRes.data
      };
    },
    {
      enabled: !!params.orgId,
      select: (raw) => {
        const lockMap = {};
        if (Array.isArray(raw.locks)) {
          raw.locks.forEach((lock) => {
            lockMap[lock.app_id] = lock;
          });
        }

        return {
          applications: raw.applications,
          lockedAppsMap: lockMap
        };
      },
      onSuccess: (data) => {
        setAllApplications(data.applications);
        setLockedAppsMap(data.lockedAppsMap);
      },
      onError: handleApiError
    }
  );

  if (isLoading) {
    return <Loader width={70} />;
  }

  if (error) {
    return <div>Error loading applications.</div>;
  }

  return (
    <ApplicationView
      applications={data.applications}
      lockedAppsMap={lockedAppsMap}
      setLockedAppsMap={setLockedAppsMap}
    />
  );
};

export default Application;
